// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Profile_avatar__T_nRq","avatar_xl":"Profile_avatar_xl__xDkBj","avatar_img":"Profile_avatar_img__2bk2u","avatar__img":"Profile_avatar__img__3gdLd"};